import React, { useEffect, useState } from "react";
import axios from "axios";

import { DashboardSidebar } from "./Broadcaster/components/DashboardSidebar";
import AdminDashboardSidebar from "../components/DashboardSidebar";

export const UserProfileReadOnly = props => {
  const [userInfo, setUserInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    dob: "",
    position: ""
  });

  const getUserInfo = () => {
    axios.get(`/api/user/profile/${props.match.params.id}`).then(user => {
      setUserInfo(user.data);
    });
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  const { role } = props.state;
  return (
    <div className="dashboard--has-sidebar">
      {role === "admin" ? (
        <AdminDashboardSidebar {...props} />
      ) : (
        <DashboardSidebar {...props} />
      )}
      <div className="dashboard">
        <main className="wrapper">
          <section className="section">
            <div className="content">
              <div className="admin-dashboard__grid">
                <div className="latest-posts">
                  <header className="d-flex w-100 justify-content-between align-items-center mb-4">
                    <h1 className="title mb-0 h4">User Profile</h1>
                  </header>
                  <div className="form-group form-row">
                    <label className="col-lg-3 control-label">
                      First name:
                    </label>
                    <div className="col-lg-9">
                      <input
                        className="form-control"
                        name="firstName"
                        type="text"
                        value={userInfo.firstName}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-lg-3 control-label">Last name:</label>
                    <div className="col-lg-9">
                      <input
                        className="form-control"
                        name="lastName"
                        type="text"
                        value={userInfo.lastName}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-lg-3 control-label">Email:</label>
                    <div className="col-lg-9">
                      <input
                        className="form-control"
                        name="email"
                        type="text"
                        value={userInfo.email}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-lg-3 control-label">Dob:</label>
                    <div className="col-lg-9">
                      <input
                        className="form-control"
                        name="dob"
                        type="text"
                        value={userInfo.dob}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group form-row">
                    <label className="col-lg-3 control-label">Position:</label>
                    <div className="col-lg-9">
                      <input
                        className="form-control"
                        name="position"
                        type="text"
                        value={userInfo.position}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};
